
import {
  FIRST_NAME_RECEIVER_SINGLE,
  LAST_NAME_RECEIVER_SINGLE,
  NATIONAL_CODE_RECEIVER_SINGLE,
  POSTAL_CODE_RECEIVER_SINGLE,
  MOBILE_NUMBER_RECEIVER_SINGLE,
  PHONE_NUMBER_RECEIVER_SINGLE,
  ADDRESS_RECEIVER_SINGLE,
  EMAIL_RECEIVER_SINGLE,
  COMPANY_RECEIVER_SINGLE,
  LAT_RECEIVER_SINGLE,
  LNG_RECEIVER_SINGLE,
  CITY_NAME_RECEIVER_SINGLE,
  CITY_ID_RECEIVER_SINGLE,
  STATE_NAME_RECEIVER_SINGLE,
  STATE_ID_RECEIVER_SINGLE,
  NEED_RECEIVER_SINGLE,
  COUNTRY_NAME_RECEIVER_SINGLE,
  COUNTRY_ID_RECEIVER_SINGLE,
  COUNTRY_NAME_EN_RECEIVER_SINGLE,
  COUNTRY_CITY_RECEIVER_SINGLE
} from "../../Types";

export const setFirstNameReceiver = (payload) => {
  return {
    type: FIRST_NAME_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setLastNameReceiver = (payload) => {
  return {
    type: LAST_NAME_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setNationalCodeReceiver = (payload) => {
  return {
    type: NATIONAL_CODE_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setPostalCodeReceiver = (payload) => {
  return {
    type: POSTAL_CODE_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setAddressReceiver = (payload) => {
  return {
    type: ADDRESS_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setMobileNumberReceiver = (payload) => {
  return {
    type: MOBILE_NUMBER_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setPhoneNumberReceiver = (payload) => {
  return {
    type: PHONE_NUMBER_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setCityNameReceiver = (payload) => {
  return {
    type: CITY_NAME_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setCityIDReceiver = (payload) => {
  return {
    type: CITY_ID_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setStateNameReceiver = (payload) => {
  return {
    type: STATE_NAME_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setStateIDReceiver = (payload) => {
  return {
    type: STATE_ID_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setCountryNameReceiver = (payload) => {
  return {
    type: COUNTRY_NAME_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setCountryIDReceiver = (payload) => {
  return {
    type: COUNTRY_ID_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setCountryNameENReceiver = (payload) => {
  return {
    type: COUNTRY_NAME_EN_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setCountryCityReceiver = (payload) => {
  return {
    type: COUNTRY_CITY_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setLatReceiver = (payload) => {
  return {
    type: LAT_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setLngReceiver = (payload) => {
  return {
    type: LNG_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setEmailReceiver = (payload) => {
  return {
    type: EMAIL_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setCompanyReceiver = (payload) => {
  return {
    type: COMPANY_RECEIVER_SINGLE,
    payload: payload,
  };
};
export const setNeedReceiver = (payload) => {
  return {
    type: NEED_RECEIVER_SINGLE,
    payload: payload,

  };
};
